<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="3" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Add Coin Seller / Merchant
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <v-autocomplete
                ref="type"
                outlined
                v-model="form.type"
                :items="typeItems"
                label="Type *"
                prepend-inner-icon="mdi-account-badge"
                clearable
                :rules="[rules.required]"
                :error-messages="errors.type"
              ></v-autocomplete>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.unique_id"
                outlined
                type="number"
                label="Enter Unique ID *"
                prepend-inner-icon="mdi-identifier"
                :rules="[rules.required]"
                hint="Enter the Unique ID of the user"
                :error-messages="errors.unique_id"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.whatsapp_no"
                outlined
                type="tel"
                maxlength="15"
                label="WhatsApp Number *"
                prepend-inner-icon="mdi-whatsapp"
                :rules="[rules.required]"
                hint="Enter WhatsApp Number of the user"
                :error-messages="errors.whatsapp_no"
              ></v-text-field>
            </v-col>
            <v-col sm="3">
              <v-text-field
                v-model="form.balance"
                outlined
                type="number"
                min="0"
                label="Initial Balance *"
                prepend-inner-icon="mdi-bitcoin"
                :rules="[rules.required]"
                hint="Enter the initial wallet balance"
                :error-messages="errors.balance"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CoinSellerMerchantCreatePage",
  data() {
    return {
      form: {
        type: null,
        unique_id: null,
        whatsapp_no: null,
        balance: 0,
      },
      typeItems: [
        { text: "Coin Seller", value: "coin_seller" },
        { text: "Merchant", value: "merchant" },
      ],
      isLoading: false,
      errors: {},
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  mounted() {
    // Initialize
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.errors = {};

        // Validate required fields
        if (!this.form.type || !this.form.unique_id || !this.form.whatsapp_no || !this.form.balance) {
          alert("Please fill all required fields.");
          this.isLoading = false;
          return;
        }

        // API call to create coin seller/merchant
        let response = await axios.post("/coin-seller-merchant/create", this.form);

        console.log("Response:", response.data);

        // Save timestamp log
        await this.saveUserTimestamp(null, this.form);

        // Success message
        alert(
          response.data.message ||
            "Coin Seller/Merchant created successfully!"
        );

        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        this.isLoading = false;

        console.log("error", e);

        if (e.response && e.response.data) {
          if (e.response.data.errors) {
            this.errors = e.response.data.errors;
            let msg = e.response.data.message || "Validation error occurred.";
            alert(msg);
          } else if (e.response.data.message) {
            alert(e.response.data.message);
          } else {
            alert("Unexpected server error.");
          }
        } else {
          alert(
            "Network error: Cannot reach server. Please check if backend is running."
          );
        }
      }
    },

    async saveUserTimestamp(oldData, newData) {
      try {
        let form = {
          from_path: `/coinseller-merchants/create`,
          from_name: "CoinSellerMerchantCreatePage",
          user_id: this.$store.state.user?.id,
          old_json: oldData ? JSON.stringify(oldData) : null,
          new_json: JSON.stringify(newData),
        };
        await axios.post(`/user_timestamps`, form);
      } catch (error) {
        console.log("timestamp error", error);
      }
    },
  },
};
</script>
